import { IconButton, Stack } from '@ltvco/refresh-lib/theme';
import { Close } from '@mui/icons-material';

import { UpgradePlanPage } from 'routes/Upgrade/UpgradePlanPage';

interface UpgradePlanPageProps {
  contactUsHandler: () => void;
  onCloseUpgradePlan: () => void;
}

export const UpgradePlanChatPage = ({
  contactUsHandler,
  onCloseUpgradePlan,
}: UpgradePlanPageProps) => {
  return (
    <Stack width="100%" flexDirection="column">
      <Stack width="100%" justifyContent="flex-end" flexDirection="row">
        <IconButton onClick={onCloseUpgradePlan}>
          <Close />
        </IconButton>
      </Stack>
      <UpgradePlanPage contactUsHandler={contactUsHandler} />
    </Stack>
  );
};
